(function() {
    'use strict';
 
 a3_cabin_reports.controller('LeaveRequestInstructionsCtrl',LeaveRequestInstructionsCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name LeaveRequestInstructionsCtrl
    * @description 
    *   Get the Leave Request Instructions
    * @ngInject
    */
function LeaveRequestInstructionsCtrl($scope, $uibModalInstance){
		$scope.page = 1;
		$scope.cancel = cancel;
        $scope.nextPage = nextPage;
        $scope.previousPage = previousPage;
    
        $scope.instructionPages = 3;
    
        /**
         * Goes to the next page of  leave instructions
         * @memberof LeaveRequestInstructionsCtrl
         */
        function nextPage(){
           $scope.page = $scope.page + 1;
           normalizePage();
        }
        
         /**
         * Goes to the previous page of leave instructions
         * @memberof LeaveRequestInstructionsCtrl
         */
        function previousPage(){
             $scope.page = $scope.page - 1;
             normalizePage();
        }
        
        /**
         * Normalize the page number if it is out of range
         * @memberof LeaveRequestInstructionsCtrl
         */
        function normalizePage(){
            if($scope.page > $scope.instructionPages || $scope.page<1){
                $scope.page = 1;
           }
        }
        /**
         * Close the modal
         * @memberof LeaveRequestInstructionsCtrl
         */
		function cancel() {
			$uibModalInstance.close('close');
		};
		
	}
 })();   